export const translations = {
  configuration: {
    userProfile: {
      tabs: {
        courses: {
          rowsCount: 'curso asignado',
          rowsCountPlural: 'cursos asignados',
          header: {
            title: 'Cursos',
            description:
              'Acá podrás ver todos los cursos y perfiles LMS asignados al colaborador.'
          },
          name: 'Nombre del curso',
          profiles: 'Perfil LMS',
          mandatory: {
            title: 'Obligatoriedad',
            required: 'Obligatorio',
            optional: 'Opcional'
          },
          type: 'Tipo de curso',
          advance: 'Avance',
          approvalStatus: 'Estado de aprobación',
          period: 'Periodo de cursado',
          emptyState: {
            noMatches: 'No hay cursos que coincidan con la búsqueda.',
            noCourses: 'No hay cursos disponibles en este momento.'
          }
        },
        certificates: {
          rowsCount: 'certificado',
          rowsCountPlural: 'certificados',
          header: {
            title: 'Certificados',
            description:
              'Revisa y descarga los certificados obtenidos en los cursos completados.'
          },
          name: 'Nombre del certificado',
          mandatory: {
            title: 'Obligatoriedad',
            required: 'Obligatorio',
            optional: 'Opcional'
          },
          type: 'Tipo de curso',
          download: 'Descargar',
          downloadSelectedCertificates:
            'Descargar certificados seleccionados {total}',
          notifications: {
            download:
              'El certificado ha sido descargado con éxito. Encuéntralo en tu carpeta de descargas.',
            downloadSelected:
              'Los certificados se están generando. Los recibirás por correo en un archivo ZIP en breve.'
          },
          emptyState: {
            noMatches: 'No hay certificados que coincidan con la búsqueda.',
            noCertificates: 'No hay certificados disponibles.'
          }
        }
      }
    }
  }
}
